import { useMutation, useQuery } from '../../../hooks';
import { AdminCacheKeys } from '../consts';

import * as adminService from '../service';

export const useDatastreams = () => {
  const getDatastreams = useQuery({
    queryKey: [AdminCacheKeys.GetDatastreams],
    queryFn: adminService.getDatastreams,
  });

  const getDatastreamFetchStatus = useMutation({
    mutationFn: adminService.getDatastreamFetchStatus,
  });

  const triggerRefreshMutation = useMutation({
    mutationFn: adminService.refreshDatastreams,
  });

  const fetchDatastreamsData = useMutation({
    mutationFn: adminService.fetchDatastreamsData,
  });

  return {
    getDatastreams,
    getDatastreamFetchStatus,
    triggerRefreshMutation,
    fetchDatastreamsData,
  };
};
